import ErrorIcon from '@mui/icons-material/Error';
import InputAdornment from '@mui/material/InputAdornment';
import { MuiTelInput } from 'mui-tel-input';
import type { MuiTelInputInfo } from 'mui-tel-input';
import { Controller, useController, useFormContext } from 'react-hook-form';

function PhoneNumberFormField() {
  const { control } = useFormContext();
  const {
    field: { onChange: onPhoneChange }
  } = useController({
    name: 'phone'
  });
  const {
    field: { onChange: onPhoneCodeChange }
  } = useController({
    name: 'phoneCode'
  });

  return (
    <Controller
      name="fullPhoneNumber"
      control={control}
      render={({ field: { ref, onChange, ...restOfFields }, fieldState }) => (
        <MuiTelInput
          {...restOfFields}
          inputRef={ref}
          onChange={
            // istanbul ignore next
            (value: string, info: MuiTelInputInfo) => {
              const { countryCallingCode, nationalNumber } = info;
              onPhoneCodeChange(countryCallingCode);
              onPhoneChange(nationalNumber);
              onChange(value);
            }
          }
          fullWidth
          required
          forceCallingCode
          defaultCountry="US"
          preferredCountries={['US', 'CA', 'MX']}
          label="Phone Number"
          error={!!fieldState.error?.message}
          helperText={fieldState.error?.message as React.ReactNode}
          InputLabelProps={{
            sx: theme => ({
              '&.MuiInputLabel-shrink': {
                backgroundColor: theme.palette.tofu.light,
                fontSize: '18px',
                paddingRight: '5px'
              },
              variant: 'outlined'
            })
          }}
          InputProps={{
            endAdornment:
              // istanbul ignore next
              !!fieldState.error?.message ? (
                <InputAdornment position="end">
                  <ErrorIcon color="error" />
                </InputAdornment>
              ) : null
          }}
        />
      )}
    />
  );
}

export default PhoneNumberFormField;
